import { React, useState, useEffect } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import { useDrag } from 'react-dnd';


export default function SongListCriteriaItem(props) {

    const [ { isDragging }, drag] = useDrag(() => ({
        type: props.criteriaType,
        item: props.item,
        collect: (monitor) => (
        {
            isDragging: !!monitor.isDragging()
        })
    }),
    [props.itemCount])
return(
<ListGroup.Item ref={drag} key={props.item.itemId} action active={isDragging} >{props.item.itemDescription}</ListGroup.Item>
)
}